import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { WHATSAPP } from "@/lib/site";
import { MessageCircle } from "lucide-react";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" }), [pathname]);
  return null;
};

export const Layout = () => {
  return (
    <div className="min-h-screen bg-[#FFFFFF]">
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <a
        href={WHATSAPP}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#2C2A29] text-[#FFFFFF] flex items-center justify-center shadow-lg hover:bg-[#9E8773] transition-colors"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={22} />
      </a>
    </div>
  );
};
